import { faArrowUpRightFromSquare, faEnvelope, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SmbUnauthorizedContent = () => (
  <div className="flex-1 flex items-center justify-center min-h-screen bg-[#f3f3f3] p-6">
    <div className="w-full max-w-[560px] flex flex-col items-center gap-6 text-center">
      <div className="w-16 h-16 bg-error-50 rounded-2xl flex items-center justify-center">
        <FontAwesomeIcon icon={faShieldHalved} className="text-error-500" size="2x" />
      </div>

      <div className="flex flex-col gap-3">
        <h1 className="text-2xl font-bold text-black-100">Acceso no autorizado</h1>
        <p className="text-gray-400">
          No tienes permiso para acceder a <strong className="text-black-100">Inventario Inteligente</strong>.
        </p>
        <p className="text-gray-400">
          Para habilitar esta herramienta, contacta a la oficina de{' '}
          <strong className="text-black-100">GS1 México</strong> y solicita la activación.
        </p>
      </div>

      <div className="w-full bg-gray-50 border border-gray-100 rounded-xl p-4 text-left flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#003087] rounded-lg flex items-center justify-center shrink-0">
            <span className="text-white text-xs font-bold">GS1</span>
          </div>
          <div>
            <p className="font-semibold text-black-100 text-sm">GS1 México</p>
            <p className="text-xs text-gray-500">Oficina de Asociados</p>
          </div>
        </div>

        <a
          href="https://www.gs1mexico.org"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg p-3 hover:bg-gray-100 transition-colors no-underline">
          <div className="w-8 h-8 bg-white border border-gray-100 rounded-lg flex items-center justify-center shrink-0">
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-gray-500" size="sm" />
          </div>
          <div>
            <p className="font-medium text-black-100 text-sm">www.gs1mexico.org</p>
            <p className="text-xs text-gray-500">Sitio web oficial</p>
          </div>
        </a>
      </div>

      <a
        href="mailto:soporte@gs1mexico.org?subject=Solicitud%20de%20acceso%20a%20Inventario%20Inteligente"
        className="flex items-center justify-center gap-2 bg-primary hover:bg-primaryDark text-white rounded-full py-3 px-8 font-medium transition-colors no-underline">
        <FontAwesomeIcon icon={faEnvelope} size="sm" />
        Solicitar acceso a Inventario Inteligente
      </a>

      <p className="text-sm text-gray-500">
        Si ya realizaste la solicitud, tu acceso se activará en un plazo de{' '}
        <strong className="text-gray-400">1 a 2 días hábiles</strong>. Recibirás un correo de confirmación cuando esté
        listo.
      </p>
    </div>
  </div>
);

export default SmbUnauthorizedContent;
